import { render } from "./MatrixQuestion.vue?vue&type=template&id=4ca71518"
import script from "./MatrixQuestion.vue?vue&type=script&lang=js"
export * from "./MatrixQuestion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jarre\\OneDrive\\Desktop\\MSD\\msd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__